<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col sm="6" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kode Fasyankes')}" label="Kode Fasyankes">
							<b-form-input v-model="models.kodeFasyankesPelakuUsaha" v-validate="'required'" data-vv-name="Kode Fasyankes">
							</b-form-input>
							<div v-if="errors.has('Kode Fasyankes')">
								<p class="text-danger">{{ errors.first('Kode Fasyankes') }}</p>
							</div>
						</b-form-group>
                        <b-form-group v-bind:class="{ 'is-invalid': errors.has('Limbah B3')}" label="Limbah B3">
							<select v-model="models.limbahId" v-validate="'required'" data-vv-name="Limbah B3"
								class="form-control">
								<option value="">Pilih Limbah B3</option>
								<option v-for="(v,i) in masters.limbahB3" :value="v.id" :key="i">
									{{v.namaLimbah}}
								</option>
							</select>
							<div v-if="errors.has('Limbah B3')">
								<p class="text-danger">{{ errors.first('Limbah B3') }}</p>
							</div>
						</b-form-group>
					</b-col>
                    <b-col sm="6" class="mb-2">
                        <b-form-group v-bind:class="{ 'is-invalid': errors.has('Nomor Manifest')}" label="Nomor Manifest">
							<b-form-input v-model="models.nomorManifest" v-validate="'required'" data-vv-name="Nomor Manifest">
							</b-form-input>
							<div v-if="errors.has('Nomor Manifest')">
								<p class="text-danger">{{ errors.first('Nomor Manifest') }}</p>
							</div>
						</b-form-group>
                    </b-col>
                    <b-col sm="6" class="mb-2">
                        <b-form-group v-bind:class="{ 'is-invalid': errors.has('Tanggal Diangkut')}" label="Tanggal Diangkut">
							<b-form-input type="date" v-model="models.tglDiangkut" v-validate="'required'" data-vv-name="Tanggal Diangkut">
							</b-form-input>
							<div v-if="errors.has('Tanggal Diangkut')">
								<p class="text-danger">{{ errors.first('Tanggal Diangkut') }}</p>
							</div>
						</b-form-group>
                        <b-form-group v-bind:class="{ 'is-invalid': errors.has('Perusahaan Pengangkut')}" label="Perusahaan Pengangkut">
                            <b-form-input v-model="models.perusahaanPengangkut" v-validate="'required'" data-vv-name="Perusahaan Pengangkut">
                            </b-form-input>
                            <div v-if="errors.has('Perusahaan Pengangkut')">
                                <p class="text-danger">{{ errors.first('Perusahaan Pengangkut') }}</p>
                            </div>
                        </b-form-group>
                        <b-form-group v-bind:class="{ 'is-invalid': errors.has('Berat Diangkut')}" label="Berat Diangkut">
                            <b-form-input type="number" step="any" v-model="models.beratDiAngkut" v-validate="'required'" data-vv-name="Berat Diangkut">
                            </b-form-input>
                            <div v-if="errors.has('Berat Diangkut')">
                                <p class="text-danger">{{ errors.first('Berat Diangkut') }}</p>
                            </div>
                        </b-form-group>
                    </b-col>
                    <b-col sm="6" class="mb-2">
                        <b-form-group v-bind:class="{ 'is-invalid': errors.has('Tanggal Diterima')}" label="Tanggal Diterima">
							<b-form-input type="date" v-model="models.tglDiterima" v-validate="'required'" data-vv-name="Tanggal Diterima">
							</b-form-input>
							<div v-if="errors.has('Tanggal Diterima')">
								<p class="text-danger">{{ errors.first('Tanggal Diterima') }}</p>
							</div>
						</b-form-group>
                        <b-form-group v-bind:class="{ 'is-invalid': errors.has('Perusahaan Penerima')}" label="Perusahaan Penerima">
                            <b-form-input v-model="models.perusahaanPenerima" v-validate="'required'" data-vv-name="Perusahaan Penerima">
                            </b-form-input>
                            <div v-if="errors.has('Perusahaan Penerima')">
                                <p class="text-danger">{{ errors.first('Perusahaan Penerima') }}</p>
                            </div>
                        </b-form-group>
                        <b-form-group v-bind:class="{ 'is-invalid': errors.has('Berat Diterima')}" label="Berat Diterima">
                            <b-form-input type="number" step="any" v-model="models.beratDiTerima" v-validate="'required'" data-vv-name="Berat Diterima">
                            </b-form-input>
                            <div v-if="errors.has('Berat Diterima')">
                                <p class="text-danger">{{ errors.first('Berat Diterima') }}</p>
                            </div>
                        </b-form-group>
                    </b-col>
                    
				</b-row>
				<template #footer>
					<b-button type="submit" variant="primary" class="btn-min-width float-right">
						Simpan
					</b-button>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';

	export default {
		name: 'FormSiraja',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {
                    kodeFasyankesPelakuUsaha: "",
                    limbahId: "",
                    tglImport: "",
                    tglDiangkut: "",
                    perusahaanPengangkut: "",
                    beratDiAngkut: 0,
                    tglDiterima: "",
                    perusahaanPenerima: "",
                    beratDiTerima: 0,
                    nomorManifest: ""
				},
				masters: {
					limbahB3: []
				},
			}
		},
		created() {
			const _ = this
			_.getById();
            _.getLimbah();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`Siraja/${_.$route.params.id}`);
						const data = request.data.data;
                        _.models.id  =  data.id;
						_.models.kodeFasyankesPelakuUsaha = data.kodeFasyankesPelakuUsaha;
						_.models.limbahId = data.limbahId;
						_.models.tglImport = data.tglImport;
						_.models.tglDiangkut = data.tglDiangkut;
						_.models.perusahaanPengangkut = data.perusahaanPengangkut;
						_.models.beratDiAngkut = data.beratDiAngkut;
						_.models.tglDiterima = data.tglDiterima;
						_.models.perusahaanPenerima = data.perusahaanPenerima;
						_.models.beratDiTerima = data.beratDiTerima;
						_.models.nomorManifest = data.nomorManifest;
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
            getLimbah(reset = true) {
				const _ = this
				_.$axios.get('LimbahB3')
				.then(res => {
					_.masters.limbahB3 = res.data.data;
				});
			},
			save() {
				const _ = this;
				_.$validator.validate().then(valid => {
					if (valid) {
						_.$axios.put(`Siraja/${_.$route.params.id}`, _.models)
						.then(() => _.$router.push({
							name: _.config.uri
						}))
						.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
						
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>